import { Controller } from "@hotwired/stimulus"

// A password field's show/hide button (components/input with reveal: true, TMS-1655): switches the
// field between hidden and plain text so the person can check what they typed. The button keeps its
// "Show password" name and reports the state through aria-pressed.
export default class extends Controller {
  static targets = ["icon"]

  toggle() {
    const input = this.element.closest(".app-input-container").querySelector("input")
    const show = input.type === "password"

    input.type = show ? "text" : "password"
    this.element.setAttribute("aria-pressed", String(show))
    this.iconTarget.classList.toggle("ph-eye", !show)
    this.iconTarget.classList.toggle("ph-eye-slash", show)
  }
}
